(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    let opener;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-localization-open]');
      if (trigger) {
        opener = trigger;
        window.setTimeout(() => {
          const drawer = document.querySelector('[data-localization-drawer][aria-hidden="false"]');
          drawer?.querySelector('.localization-drawer__panel')?.focus({ preventScroll: true });
        }, 60);
      }
      if (event.target.closest('[data-localization-drawer] [data-localization-close]')) {
        opener?.focus({ preventScroll: true });
      }
    });
    document.addEventListener('keydown', (event) => {
      const drawer = document.querySelector('[data-localization-drawer][aria-hidden="false"]');
      if (!drawer) return;
      if (event.key === 'Escape') {
        opener?.focus({ preventScroll: true });
      }
      if (event.key !== 'Tab') return;
      const controls = Array.from(drawer.querySelectorAll('a[href], button, input:not([type="hidden"]), select'))
        .filter((control) => !control.disabled && control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      const panel = drawer.querySelector('.localization-drawer__panel');
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
